import { addDaysIso, getTodaySaoPaulo } from "./dateUtils";

export type DashboardPeriodo = "hoje" | "ontem" | "7" | "30" | "mes" | "mes_passado" | "personalizado";

export function getDashboardPeriodoRange(
  periodo: DashboardPeriodo,
  custom: { start: string; end: string } | null = null,
  today = getTodaySaoPaulo(),
): { start: string; end: string } | null {
  switch (periodo) {
    case "hoje": return { start: today, end: today };
    case "ontem": {
      const yesterday = addDaysIso(today, -1);
      return { start: yesterday, end: yesterday };
    }
    case "7": return { start: addDaysIso(today, -6), end: today };
    case "30": return { start: addDaysIso(today, -29), end: today };
    case "mes": return { start: `${today.slice(0, 7)}-01`, end: today };
    case "mes_passado": {
      const end = addDaysIso(`${today.slice(0, 7)}-01`, -1);
      return { start: `${end.slice(0, 7)}-01`, end };
    }
    case "personalizado":
      if (!custom?.start || !custom.end) return null;
      return custom.start <= custom.end ? custom : { start: custom.end, end: custom.start };
  }
}
